module.exports = __webpack_public_path__ + "img/isp-protezione.d37077d4.jpg";